var _defineProperty = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _ExampleProjects;

var _require = require('./constants'),
    BLOCK_LEVEL_TYPES = _require.BLOCK_LEVEL_TYPES,
    HARDWARE_TYPES = _require.HARDWARE_TYPES,
    PROJECT_TYPES = _require.PROJECT_TYPES,
    GAMEPAD_TYPES = _require.GAMEPAD_TYPES;

var _require2 = require('./gamepadExampleProjects'),
    GamepadExampleProjects = _require2.GamepadExampleProjects;

var ebot_sim = require('./exampleNoGamepadProjects/ebot_sim');

var led_sim = require('./exampleNoGamepadProjects/led_sim');

var matrix_sim = require('./exampleNoGamepadProjects/matrix_sim');

var no_hardware = require('./exampleNoGamepadProjects/no_hardware');

var ebot_basic_4wd = require('./exampleNoGamepadProjects/ebot_basic_4wd');

var ebot_mini_tank_4wd = require('./exampleNoGamepadProjects/ebot_mini_tank_4wd');

var ebot_junior_tank_4wd_2dof = require('./exampleNoGamepadProjects/ebot_junior_tank_4wd_2dof');

var ebot_flipper_tank_4wd_1dof = require('./exampleNoGamepadProjects/ebot_flipper_tank_4wd_1dof');

var ebot_pro_2wd_3dof = require('./exampleNoGamepadProjects/ebot_pro_2wd_3dof');

var ebot_pro_omni_3dof = require('./exampleNoGamepadProjects/ebot_pro_omni_3dof');

var ebot_scout_omni_5dof = require('./exampleNoGamepadProjects/ebot_scout_omni_5dof');

var ebot_rescue_6wd_5dof = require('./exampleNoGamepadProjects/ebot_rescue_6wd_5dof');

var servo_crane = require('./exampleNoGamepadProjects/servo_crane');

var stepper_crane = require('./exampleNoGamepadProjects/stepper_crane');

var drone_pad = require('./exampleNoGamepadProjects/drone_pad');

var conveyor_sorter = require('./exampleNoGamepadProjects/conveyor_sorter');

var traffic_lights = require('./exampleNoGamepadProjects/traffic_lights');

var exampleJS = require('./codingProjects/hardwareJS/exampleJS.json');

var examplePY = require('./codingProjects/hardwarePY/examplePY.json');

var ScratchEbotEmptyProject = 'ScratchEbotEmptyProject';
var ScratchMatrixSimEmptyProject = 'ScratchMatrixSimEmptyProject';
var ScratchLedSimEmptyProject = 'ScratchLedSimEmptyProject';
var ScratchEbotSimEmptyProject = 'ScratchEbotSimEmptyProject';
/*
    CUSTOM EMPTY PROJECTS

    * Have to be defined as exactly 'Empty Project'
    * Have to be defined as a CODINGPROJECT ([PROJECT_TYPES.CHALLEGE])
    * If used then all 3 block leves have to be defined
    
    Example...

    'Empty Project': {
        [PROJECT_TYPES.CODINGPROJECT]: {
            [BLOCK_LEVEL_TYPES.BEGINNER]: {
                scratch:{ scratchProject: ScratchDemoRemoteControlSumoBeginnerCoreProject,
                projectVideoId: 'dv6etKxr',
                projectResourcesLink: 'https://google.com',
                projectInfo: 'Some help info here' }
            },
            [BLOCK_LEVEL_TYPES.CORE]: {
                scratch:{ scratchProject: ScratchDemoRemoteControlSumoBeginnerCoreProject,
                projectVideoId: 'dv6etKxr',
                projectResourcesLink: 'https://google.com',
                projectInfo: 'Some help info here' }
            },
            [BLOCK_LEVEL_TYPES.ADVANCED]: {
                scratch:{ scratchProject: ScratchDemoScratchRemoteControlSumoAdvancedProject,
                projectVideoId: 'dv6etKxr',
                projectResourcesLink: 'https://google.com',
                projectInfo: 'Some help info here' }
            }
        }
    },
*/
//Exception: [HARDWARE_TYPES.no_hardware] will use the challenges present in ExampleProjects when no_gamepad is selected.
//           If a gamepad is selected then GamepadExampleProjects will be used instead and the challenges in that object will be used
//Object layout: Hardware Type -> Challenge Name -> Project Type -> Block Level -> scratch|webappJS

var ExampleProjects = (_ExampleProjects = {}, _defineProperty(_ExampleProjects, HARDWARE_TYPES.ebot_sim, ebot_sim), _defineProperty(_ExampleProjects, HARDWARE_TYPES.led_sim, led_sim), _defineProperty(_ExampleProjects, HARDWARE_TYPES.matrix_sim, matrix_sim), _defineProperty(_ExampleProjects, HARDWARE_TYPES.no_hardware, no_hardware), _defineProperty(_ExampleProjects, HARDWARE_TYPES.ebot_basic_4wd, ebot_basic_4wd), _defineProperty(_ExampleProjects, HARDWARE_TYPES.ebot_mini_tank_4wd, ebot_mini_tank_4wd), _defineProperty(_ExampleProjects, HARDWARE_TYPES.ebot_flipper_tank_4wd_1dof, ebot_flipper_tank_4wd_1dof), _defineProperty(_ExampleProjects, HARDWARE_TYPES.ebot_junior_tank_4wd_2dof, ebot_junior_tank_4wd_2dof), _defineProperty(_ExampleProjects, HARDWARE_TYPES.ebot_pro_2wd_3dof, ebot_pro_2wd_3dof), _defineProperty(_ExampleProjects, HARDWARE_TYPES.ebot_pro_omni_3dof, ebot_pro_omni_3dof), _defineProperty(_ExampleProjects, HARDWARE_TYPES.ebot_scout_omni_5dof, ebot_scout_omni_5dof), _defineProperty(_ExampleProjects, HARDWARE_TYPES.ebot_rescue_6wd_5dof, ebot_rescue_6wd_5dof), _defineProperty(_ExampleProjects, HARDWARE_TYPES.servo_crane, servo_crane), _defineProperty(_ExampleProjects, HARDWARE_TYPES.stepper_crane, stepper_crane), _defineProperty(_ExampleProjects, HARDWARE_TYPES.drone_pad, drone_pad), _defineProperty(_ExampleProjects, HARDWARE_TYPES.conveyor_sorter, conveyor_sorter), _defineProperty(_ExampleProjects, HARDWARE_TYPES.traffic_lights, traffic_lights), _ExampleProjects);
/**
 * Get example projects that are relevent to each app
 * This function will also make sure the parent objects like hardwareTypes are only included if there is a relevent example project within that
 * @param app {'scratch'|'webappJS'|'webappPY'}
 */

var getExampleProjectsByApp = function getExampleProjectsByApp(app) {
  var hardwareTypes = Object.keys(ExampleProjects);
  var newHardwareTypes = {};

  for (var i = 0; i < hardwareTypes.length; i++) {
    var _PROJECT_TYPES$CUSTOM, _PROJECT_TYPES$CUSTOM2, _PROJECT_TYPES$CUSTOM3, _PROJECT_TYPES$CUSTOM4, _PROJECT_TYPES$CUSTOM5, _PROJECT_TYPES$CUSTOM6;

    var challengeTypes = Object.keys(ExampleProjects[hardwareTypes[i]]);
    var newChallengeTypes = {};

    for (var j = 0; j < challengeTypes.length; j++) {
      var projectTypes = Object.keys(ExampleProjects[hardwareTypes[i]][challengeTypes[j]]);
      var newProjectTypes = {};

      for (var k = 0; k < projectTypes.length; k++) {
        var blockLevelTypes = Object.keys(ExampleProjects[hardwareTypes[i]][challengeTypes[j]][projectTypes[k]]);
        var newBlockLevels = {};

        for (var l = 0; l < blockLevelTypes.length; l++) {
          var project = ExampleProjects[hardwareTypes[i]][challengeTypes[j]][projectTypes[k]][blockLevelTypes[l]];
          if (app === 'scratch' && project.scratch) newBlockLevels[blockLevelTypes[l]] = project.scratch;
          if (app === 'webappJS' && project.webappJS) newBlockLevels[blockLevelTypes[l]] = project.webappJS;
          if (app === 'webappPY' && project.webappPY) newBlockLevels[blockLevelTypes[l]] = project.webappPY;
        }

        if (Object.keys(newBlockLevels).length !== 0) newProjectTypes[projectTypes[k]] = newBlockLevels;
      }

      if (Object.keys(newProjectTypes).length !== 0) newChallengeTypes[challengeTypes[j]] = newProjectTypes;
    }

    if (app === 'scratch') newChallengeTypes['Empty Project'] = _defineProperty({}, PROJECT_TYPES.CUSTOM, (_PROJECT_TYPES$CUSTOM = {}, _defineProperty(_PROJECT_TYPES$CUSTOM, BLOCK_LEVEL_TYPES.BEGINNER, {
      scratch: {
        scratchProject: ScratchEbotEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM, BLOCK_LEVEL_TYPES.CORE, {
      scratch: {
        scratchProject: ScratchEbotEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM, BLOCK_LEVEL_TYPES.ADVANCED, {
      scratch: {
        scratchProject: ScratchEbotEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _PROJECT_TYPES$CUSTOM));
    if (app === 'webappJS') newChallengeTypes['Empty Project'] = _defineProperty({}, PROJECT_TYPES.CUSTOM, (_PROJECT_TYPES$CUSTOM2 = {}, _defineProperty(_PROJECT_TYPES$CUSTOM2, BLOCK_LEVEL_TYPES.BEGINNER, {
      webappJS: {
        codingProject: exampleJS,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM2, BLOCK_LEVEL_TYPES.CORE, {
      webappJS: {
        codingProject: exampleJS,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM2, BLOCK_LEVEL_TYPES.ADVANCED, {
      webappJS: {
        codingProject: exampleJS,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _PROJECT_TYPES$CUSTOM2));
    if (app === 'webappPY') newChallengeTypes['Empty Project'] = _defineProperty({}, PROJECT_TYPES.CUSTOM, (_PROJECT_TYPES$CUSTOM3 = {}, _defineProperty(_PROJECT_TYPES$CUSTOM3, BLOCK_LEVEL_TYPES.BEGINNER, {
      webappPY: {
        codingProject: examplePY,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM3, BLOCK_LEVEL_TYPES.CORE, {
      webappPY: {
        codingProject: examplePY,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM3, BLOCK_LEVEL_TYPES.ADVANCED, {
      webappPY: {
        codingProject: examplePY,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _PROJECT_TYPES$CUSTOM3));
    if (app === 'scratch' && hardwareTypes[i] === HARDWARE_TYPES.matrix_sim) newChallengeTypes['Empty Project'] = _defineProperty({}, PROJECT_TYPES.CUSTOM, (_PROJECT_TYPES$CUSTOM4 = {}, _defineProperty(_PROJECT_TYPES$CUSTOM4, BLOCK_LEVEL_TYPES.BEGINNER, {
      scratch: {
        scratchProject: ScratchMatrixSimEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM4, BLOCK_LEVEL_TYPES.CORE, {
      scratch: {
        scratchProject: ScratchMatrixSimEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM4, BLOCK_LEVEL_TYPES.ADVANCED, {
      scratch: {
        scratchProject: ScratchMatrixSimEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _PROJECT_TYPES$CUSTOM4));
    if (app === 'scratch' && hardwareTypes[i] === HARDWARE_TYPES.led_sim) newChallengeTypes['Empty Project'] = _defineProperty({}, PROJECT_TYPES.CUSTOM, (_PROJECT_TYPES$CUSTOM5 = {}, _defineProperty(_PROJECT_TYPES$CUSTOM5, BLOCK_LEVEL_TYPES.BEGINNER, {
      scratch: {
        scratchProject: ScratchLedSimEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM5, BLOCK_LEVEL_TYPES.CORE, {
      scratch: {
        scratchProject: ScratchLedSimEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM5, BLOCK_LEVEL_TYPES.ADVANCED, {
      scratch: {
        scratchProject: ScratchLedSimEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _PROJECT_TYPES$CUSTOM5));
    if (app === 'scratch' && hardwareTypes[i] === HARDWARE_TYPES.ebot_sim) newChallengeTypes['Empty Project'] = _defineProperty({}, PROJECT_TYPES.CUSTOM, (_PROJECT_TYPES$CUSTOM6 = {}, _defineProperty(_PROJECT_TYPES$CUSTOM6, BLOCK_LEVEL_TYPES.BEGINNER, {
      scratch: {
        scratchProject: ScratchEbotSimEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM6, BLOCK_LEVEL_TYPES.CORE, {
      scratch: {
        scratchProject: ScratchEbotSimEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _defineProperty(_PROJECT_TYPES$CUSTOM6, BLOCK_LEVEL_TYPES.ADVANCED, {
      scratch: {
        scratchProject: ScratchEbotSimEmptyProject,
        projectVideoId: 'dv6etKxr',
        projectResourcesLink: 'https://google.com',
        projectInfo: 'Some help info here'
      }
    }), _PROJECT_TYPES$CUSTOM6));
    if (hardwareTypes[i] === HARDWARE_TYPES.no_hardware && app === 'webappJS') continue; //Webb app doesnt include no_hardware

    if (Object.keys(newChallengeTypes).length !== 0) newHardwareTypes[hardwareTypes[i]] = newChallengeTypes;
  }

  return newHardwareTypes;
};

var DisableSIMSpriteInteraction = true || window.location.hostname !== '127.0.0.1';
var HiddenSpriteNames = ['HiddenScratchSprite', 'Title', 'Start Button', 'Sumo ringOut- Game Over2', 'Out- Game Over', 'Winner- Game Time Over', 'Can Green', 'Time Over', 'Demo eBot', 'Sumo ring', 'Black Ring', 'LHS Light', 'RHS Light', 'LHS Ultra', 'RHS Ultra', 'Instructions', 'SIM eBot', 'Error', 'Info'];
module.exports = {
  GamepadExampleProjects: GamepadExampleProjects,
  ExampleProjects: ExampleProjects,
  BLOCK_LEVEL_TYPES: BLOCK_LEVEL_TYPES,
  PROJECT_TYPES: PROJECT_TYPES,
  DisableSIMSpriteInteraction: DisableSIMSpriteInteraction,
  HiddenSpriteNames: HiddenSpriteNames,
  getExampleProjectsByApp: getExampleProjectsByApp
};